import { Injectable } from '@angular/core';

import { SceneryService } from '../../scenery.service';

declare var THREE: any;

@Injectable()
export class RailingMaterialService {
  readonly typeToObjectNameMap = {
    Post: 'Post',
    'Top Rail': 'Handrail',
    'Bottom Rail': 'Bottomrail',
    Picket: 'Pickets'
  };
  constructor(private env: SceneryService) {}

  private static _tuneMaterial(shouldApply: boolean, obj: any, applier: (obj) => void) {
    if (shouldApply) {
      applier(obj);
    }
  }

  private static _updateRepeat(object, x: number, y: number) {
    const material = object.material;
    if (material.map) {
      material.map.repeat.set(x, y);
      if (material.map.image) {
        material.map.needsUpdate = true;
      }
      material.needsUpdate = true;
    }
  }

  mountMaterial = obj => {
    const material = obj.material;
    material.shininess = 5;
    material.specular.setHex(0x8d8d8d);
    material.reflectivity = 0.2;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  boltsMaterial = obj => {
    const material = obj.material;
    material.shininess = 30;
    material.specular.setHex(0xdfdfdf);
    material.reflectivity = 0.4;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  metallicMaterial = obj => {
    const material = obj.material;
    material.envMapIntensity = 0.5;
    material.roughness = 0.5;
    material.metalness = 0.7;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  wooden(obj, mapColor) {
    const material = obj.material;
    material.color.setHex(0xa3a3a3);
    material.metalness = 0.4;
    material.envMapIntensity = 1.8;
    material.roughness = 0.7;
    material.envMap = this.env.cubeMap();
    if (material.map) {
      material.color.setHex(mapColor);
    }
    material.needsUpdate = true;
  }

  woodenRail = obj => {
    this.wooden(obj, 0xababab);
    RailingMaterialService._updateRepeat(obj, 0.5, 1);
  };

  woodenPost = obj => {
    this.wooden(obj, 0xd2d2d2);
    RailingMaterialService._updateRepeat(obj, 3.5, 1);
  };

  vertCable = obj => {
    obj.castShadow = true;
    const material = obj.material;
    material.specular.setHex(0xd2d2d2);
    material.shininess = 15;
    material.reflectivity = 0.6;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  vertPicket = obj => {
    obj.castShadow = true;
    const material = obj.material;
    material.envMapIntensity = 1;
    material.roughness = 0.2;
    material.metalness = 0.5;
    // material.envMap = this.env.cubeMap();
    material.envMap = null;
    material.needsUpdate = true;
  };

  picketsWooden = obj => {
    RailingMaterialService._updateRepeat(obj, 3, 1);
  };

  tunePostAccentLightMaterial = post => {
    const obj = post.parent.getObjectByName('PostAccentLight').getObjectByName('Base');
    obj.material.color.copy(post.material.color);
    obj.material.envMap = post.material.envMap;
  };

  cable = obj => {
    const material = obj.material;
    material.envMapIntensity = 1;
    material.roughness = 0.2;
    material.metalness = 0.5;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  infillCutByFourPoints = obj => {
    const material = obj.material;
    material.specular.setHex(0xd2d2d2);
    material.shininess = 15;
    material.reflectivity = 0.6;
    material.envMap = this.env.cubeMap();
    material.needsUpdate = true;
  };

  configMaterial(obj, objectType: string, railingType: string, selected) {
    const handrailType = obj.parent.userData.entity.handrailType
      ? obj.parent.userData.entity.handrailType
      : null;
    const isWooden =
      (railingType === 'Wood' ||
        railingType === 'Composite' ||
        (obj.parent.userData.entity.modelObj.includes('rail-450-w-cap') &&
          obj.name === 'TopCap')) &&
      handrailType !== '150s';
    const name = this.typeToObjectNameMap[objectType];
    const isDefaultWood =
      selected &&
      selected.texture &&
      selected.texture.indexOf('feeney_wood_deck_redwood.jpg') !== -1;

    obj.traverse(child => {
      // TODO: think how we can avoid this condition
      const processPostCapCondition = child.name === 'Cap' && name === 'Post';

      if (child.name === name || processPostCapCondition) {
        RailingMaterialService._tuneMaterial(!isWooden, child, this.metallicMaterial);
        RailingMaterialService._tuneMaterial(
          child.name === 'Post' && isWooden,
          child,
          this.woodenPost
        );
        RailingMaterialService._tuneMaterial(
          (child.name === 'Handrail' || child.name === 'Bottomrail' || child.name === 'TopCap') &&
            isWooden,
          child,
          this.woodenRail
        );
        RailingMaterialService._tuneMaterial(child.name === 'CablesV', child, this.vertCable);
        RailingMaterialService._tuneMaterial(child.name === 'Pickets', child, this.vertPicket);
        RailingMaterialService._tuneMaterial(child.name === 'Cables', child, this.cable);
        RailingMaterialService._tuneMaterial(child.name === 'Post' && isDefaultWood, child, o =>
          RailingMaterialService._updateRepeat(o, 3, 1)
        );
        RailingMaterialService._tuneMaterial(
          child.name === 'Pickets' && isWooden,
          child,
          this.picketsWooden
        );

        if (child.name === 'Post' && child.parent.getObjectByName('PostAccentLight') && !isWooden) {
          this.tunePostAccentLightMaterial(child);
        }
      }

      RailingMaterialService._tuneMaterial(child.name === 'Mount', child, this.mountMaterial);
      RailingMaterialService._tuneMaterial(child.name === 'Bolts', child, this.boltsMaterial);
    });

    RailingMaterialService._tuneMaterial(
      ['panel', 'frameBottom', 'frameTop'].includes(obj.name),
      obj,
      this.metallicMaterial
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/services/railing-material.service.ts